<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">

  <div class="p-col-12  p-col-align-start  ">
    <!--<app-table-resultado-eleicao *ngIf="eleicao?.statusEleicao === 'APURADA' || eleicao?.statusEleicao === 'ENCERRADA' "
      [eleicaoId]="eleicao?.id"></app-table-resultado-eleicao> -->
    <div *ngIf="isManager || comprovantes?.length" class="box text-center shadow-lg p-2 mb-2 bg-white rounded"
      style="min-height: 450px !important;">
      <div class="mx-2 text-right">
        <button #printButton id="printButton" class="btn btn-outline-secondary hide-print" (click)="printPage()" style="margin-right: 9px;"
            pTooltip="Imprimir">
            <i class="fas fa-print"></i>
        </button>
    </div>
      <div class=" mx-3 text-center">
        <span class=" mx-4 text-center font-weight-bolder text-success shadow">
          <h2> Seu voto foi computado. Agradecemos por sua participação!</h2>
          <!--<h2> Seu voto já foi computado, obrigado pela participação!</h2>-->
        </span>
        <h5 class="mb-4"> Códigos de comprovação dos votos realizados:</h5>
        <div *ngIf="comprovantes?.length > 0; else semComprovantes" class="container">
          <div class="row justify-content-center">
            <div class="col-md-4" *ngFor="let comprovante of comprovantes">
              <div class="card mb-3 ">
                <div class="card-body d-flex flex-row w-10 justify-content-center">
                  <small>{{comprovante.hashComprovante}}</small>
                </div>
                <div class="card-footer text-muted p-1">
                  {{comprovante.createdAt | date: 'dd/MM/yyyy HH:mm'}}
                  <br>
                  {{comprovante.cargoNome}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #semComprovantes>
          <div class="card mb-3 ">
            <div class="card-body d-flex flex-row w-10 justify-content-center">
              Nenhum Comprovante vinculado a esse usuário nesta eleição.
            </div>
          </div>
        </ng-template>
      </div>
      <hr>
      <div class="col-md-12 py-3 text-center font-weight-bolder text-muted">
        <div [innerHtml]="eleicao?.mensagem"></div>
      </div>
    </div>
    <div *ngIf="!isManager && !comprovantes?.length && eleicao?.eleicaoEncerrada"
      class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important;">
      <h2> Eleição Encerrada!</h2>
      <br>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-4">
            <div class="card mb-3 ">
              <div class="card-body d-flex flex-row w-10 justify-content-center">
                Nenhum Comprovante vinculado a esse usuário nesta eleição.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-5 py-3 text-center font-weight-bolder text-muted">
        <div [innerHtml]="eleicao?.mensagem"></div>
      </div>
    </div>
  </div>
</div>
<app-spinner></app-spinner>